export const isAllEmpty = (obj) => {
  return Object.values(obj).every((value) => value === "");
};
